import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const DataMappingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/data-mappings" */
    'routes/Data/DataMappingsRoute'
  )
));

const UpdateDataMappingRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/update-data-mapping" */
    'routes/Data/UpdateDataMappingRoute'
  )
));

const LookupTablesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/lookup-tables" */
    'routes/Data/LookupTablesRoute'
  )
));

const LookupTableColumnsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/lookup-table-column" */
    'routes/Data/LookupTableColumnsRoute'
  )
));

const LookupTableRecordsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/lookup-table-records" */
    'routes/Data/LookupTableRecordsRoute'
  )
));

const BackgroundJobsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/background-jobs" */
    'routes/Data/BackgroundJobsRoute'
  )
));

const BackgroundJobLogsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/background-job-logs" */
    'routes/Data/BackgroundJobLogsRoute'
  )
));

const ImportJobsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/import-jobs" */
    'routes/Data/ImportJobsRoute'
  )
));

const UpdateImportJobRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/update-import-job" */
    'routes/Data/UpdateImportJobRoute'
  )
));

const ImportJobLogsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/import-job-logs" */
    'routes/Data/ImportJobLogsRoute'
  )
));

const ExportJobsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/export-jobs" */
    'routes/Data/ExportJobsRoute'
  )
));

const CsvSchemasRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/csv-schemas" */
    'routes/Data/CsvSchemasRoute'
  )
));

const CsvSchemaDetailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/csv-schema-details" */
    'routes/Data/CsvSchemaDetailsRoute'
  )
));

const TaxonomiesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/taxonomies" */
    'routes/Data/TaxonomiesRoute'
  )
));

const TaxonomyRecordsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/data/taxonomy-records" */
    'routes/Data/TaxonomyRecordsRoute'
  )
));


const getDataRoutes = () => {
  return [
    {path: paths.getPathPredefinedDataMappings(), render: (props) => <DataMappingsRoute {...props} type={constants.DMAP_TYPE_PREDEFINED} />},
    {path: paths.getPathCustomDataMappings(), render: (props) => <DataMappingsRoute {...props} type={constants.DMAP_TYPE_CUSTOM} />},
    {path: paths.getPathAddDataMapping(), component: UpdateDataMappingRoute},
    {path: paths.getPathEditDataMapping(":dmapId"), component: UpdateDataMappingRoute},
    {path: paths.getPathReplicateDataMapping(":dmapId"), render: (props) => <UpdateDataMappingRoute {...props} isReplicate={true} />},

    {path: paths.getPathPredefinedLookupTables(), render: (props) => <LookupTablesRoute {...props} type={constants.LOOKUP_TABLE_TYPE_PREDEFINED} />},
    {path: paths.getPathCustomLookupTables(), render: (props) => <LookupTablesRoute {...props} type={constants.LOOKUP_TABLE_TYPE_CUSTOM} />},
    {path: paths.getPathLookupTableColumns(":tableId"), component: LookupTableColumnsRoute},
    {path: paths.getPathLookupTableRecords(":tableId"), component: LookupTableRecordsRoute},

    {path: paths.getPathBackgroundJobs(), component: BackgroundJobsRoute},
    {path: paths.getPathBackgroundJobLogs(":jobId"), component: BackgroundJobLogsRoute},

    {path: paths.getPathImportJobs(), component: ImportJobsRoute},
    {path: paths.getPathAddImportJob(), component: UpdateImportJobRoute},
    {path: paths.getPathPreviewImportJob(":jobId"), component: UpdateImportJobRoute},
    {path: paths.getPathImportJobLogs(":jobId"), component: ImportJobLogsRoute},
    {path: paths.getPathExportJobs(), component: ExportJobsRoute},

    {path: paths.getPathCsvSchemas(), component: CsvSchemasRoute},
    {path: paths.getPathCsvSchemaDetails(":schemaKey"), component: CsvSchemaDetailsRoute},

    {path: paths.getPathTaxonomies(), component: TaxonomiesRoute},
    {path: paths.getPathTaxonomyRecords(":taxonomyKey"), component: TaxonomyRecordsRoute},
  ]
}



export { getDataRoutes };

